import {
  leaveAreaCatalogSchema,
  patchLeaveAreasResponseSchema,
  type LeaveAreaCatalog,
  type LeaveSwitchableArea,
  type PatchLeaveAreasRequest,
} from '@gb-ticket/shared-types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api';

export const leaveAreasKey = ['leave', 'areas'] as const;

/** `null` while the catalog is still loading. Missing keys stay on. */
export function leaveAreaEnabled(
  catalog: LeaveAreaCatalog | undefined,
  code: LeaveSwitchableArea,
): boolean | null {
  if (!catalog) {
    return null;
  }
  return catalog.items.find((item) => item.code === code)?.enabled ?? true;
}

export function useLeaveAreas() {
  return useQuery({
    queryKey: leaveAreasKey,
    queryFn: () => apiFetch('/leave/areas', leaveAreaCatalogSchema),
  });
}

export function usePatchLeaveArea() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: PatchLeaveAreasRequest) =>
      apiFetch('/leave/areas', patchLeaveAreasResponseSchema, {
        method: 'PATCH',
        body: JSON.stringify(body),
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: leaveAreasKey });
    },
  });
}
